import { KeyValuePair } from '../../../../documents/document-filter-item';
import { dataMember, required, typedArray } from 'santee-dcts';

export class AdminUsageEQueriesReportFilterItemsReadModel {
    @dataMember()
    @required({nullable: true})
    @typedArray(KeyValuePair)
    public items: KeyValuePair[];
}
